import { createRoot } from 'react-dom/client';
import { BrowserRouter, HashRouter, Navigate, Outlet, Route, Router, Routes, useLocation, useParams } from 'react-router-dom';

import 'antd/dist/antd.css';
import './styles/theme.css';
import './styles/global.css';



import { AuthContextProvider } from './context/AuthContext';
import ConnectLayout from './pages/connect/Layout';
import CheckAuthRoute from './components/shared/CheckAuth';
import PrivateRoute from './components/shared/PrivateRoute';
import Layout from './pages/home/Layout';




const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);

root.render(
    <BrowserRouter>
      <Routes>
          <Route element={
            <AuthContextProvider>
              <Outlet/>

           </AuthContextProvider>
            }>

            <Route path="/connect" element={<ConnectLayout/>} />
            <Route
              element={<CheckAuthRoute/>}
            >
             <Route element={<PrivateRoute/>}>
              <Route  element={<Layout/>}>
                <Route path='/' element={<></>} />
              </Route>
             
             </Route>


            </Route>
          
          </Route>




      







          {/* </Route> */}





      </Routes>

    </BrowserRouter>


);
